<ng-container *ngIf="isRebrandingBanner; then rebrandedTemplateV1 else originalTemplate"></ng-container>

<ng-template #originalTemplate>
  <section class="tw-mx-4 tw-mb-4 bdr-rad-15 explore tw-p-4 tw-shadow-z1" [routerLink]="orderUrl" (click)="handleClick()">
    <div class="header tw-flex tw-items-center">
      <img class="tw-flex-none tw-h-12 tw-w-12 tw-rounded-full tw-mr-3" src="/assets/images/delivered.gif" />
      <div class="tw-font-body tw-font-bold tw-text-400 tw-mr-2 tw-items-center tw-flex w50 tw-min-h-12" i18n="@@kitDelivered" *ngIf='order.get("type") === ApiClientConstant.Order.Type.REGIMEN'> We have delivered your treatment kit </div>
      <div class="tw-font-body tw-font-bold tw-text-400 tw-mr-2 tw-items-center tw-flex w50 tw-min-h-12" i18n="@@orderDelivered" *ngIf='order.get("type") !== ApiClientConstant.Order.Type.REGIMEN'> We have delivered your order </div>
      <div class="click-icon tw-border tw-border-gray-500 tw-rounded-full tw-w-8 tw-h-8 tw-absolute tw-right-2">
        <cs-icon class="tw-absolute" [iconName]="'chevron_right_green'"></cs-icon>
      </div>
    </div>
  </section>
</ng-template>

<ng-template #rebrandedTemplateV1>
  <section class="tw-rounded-3 tw-mx-4 tw-mb-4 tw-px-2 tw-py-3 tw-border-[2px] tw-border-solid tw-border-teal-200 tw-max-h-18 tw-box-border" style="background: linear-gradient(95deg, #E4F4F0 -6.23%, #FFF 88%);" [routerLink]="orderUrl" (click)="handleClick()">
    @if (shouldShowPartialOrderCancellationUI) {
      <div class="header tw-flex tw-items-center">
        <div>
          <cs-icon class="tw-h-12 tw-w-12" [iconName]="'order_delivered'"></cs-icon>
        </div>
        <div class="tw-ml-2 tw-flex tw-flex-col tw-min-h-12 tw-gap-1">
          <div class="tw-leading-4 tw-font-body tw-font-bold tw-text-[14px] tw-items-center tw-flex tw-pt-1">
            <span i18n="@@orderDeliveredTag">Order Delivered</span>
            <cs-icon class="tw-h-5 tw-w-5 tw-pl-2" [iconName]="'chevron_right_teal'"></cs-icon>
          </div>
          @if (cancelledProducts?.length === 1) {
            <p class="tw-text-200 tw-text-orange-500 tw-font-medium" i18n="@@productRemovedByYourDoctor">{{cancelledProducts?.length}} product removed by your doctor </p>
          } @else if (cancelledProducts?.length > 1) {
            <p class="tw-text-200 tw-text-orange-500 tw-font-medium" i18n="@@productsRemovedByYourDoctor">{{cancelledProducts?.length}} products removed by your doctor </p>
          }
        </div>
      </div>
    } @else {
      <div class="header tw-flex tw-items-center">
        <div>
          <cs-icon class="tw-h-12 tw-w-12" [iconName]="'order_delivered'"></cs-icon>
        </div>
        <div class="tw-ml-2 tw-flex tw-flex-col tw-min-h-12 tw-gap-1">
          <div class="tw-leading-4 tw-font-body tw-font-bold tw-text-[14px] tw-items-center tw-flex tw-pt-1">
            <span i18n="@@orderDeliveredTag">Order Delivered</span>
            <cs-icon class="tw-h-5 tw-w-5 tw-pl-2" [iconName]="'chevron_right_teal'"></cs-icon>
          </div>
          <div class="tw-leading-[18px] tw-font-body tw-text-gray-500 tw-font-medium tw-text-[12px] tw-items-center tw-flex" i18n="@@yourOrderIsDelivered" *ngIf='order.get("type") !== ApiClientConstant.Order.Type.REGIMEN'>
            Your order is Delivered
          </div>
          <div class="tw-leading-[18px] tw-font-body tw-text-gray-500 tw-font-medium tw-text-[12px] tw-items-center tw-flex" i18n="@@yourKitIsDelivered" *ngIf='order.get("type") === ApiClientConstant.Order.Type.REGIMEN'>
            Your treatment kit is delivered
          </div>
        </div>
      </div>
    }
  </section>
</ng-template>